export const API_URL = import.meta.env.VITE_APP_API_URL;
export const CLIENT_ID = import.meta.env.VITE_APP_CLIENT_ID;
export const REDIRECT_URI = import.meta.env.VITE_APP_REDIRECT_URI;
export const SCOPE = [];
export const SSO_URL = import.meta.env.VITE_APP_SSO_URL;
export const PERFORM_URL = import.meta.env.VITE_APP_PERFORM_URL;
